export const routes = {
  HOME: '/',
  VIP: '/vip',
  PROMOTIONS: '/promotions',
  JACKPOTS: '/jackpots',
  CASINO: '/casino',
  REGISTER: '/register',
  SPORTS: '/sports',
  TOURNAMENTS: '/tournaments',
  CHALLENGES: '/desafios',
  INFO: '/info',
  DASHBOARD: '/dashboard',
  DEPOSIT: '/deposit',
  LOGIN: '/login',
  REFERALS: '/referrals',
  NOTIFICATIONS: '/notifications',
  STREAMS: '/streams',
  RAFFLES: '/raffles',
  MARKETPLACE: '/tienda',
};
